import React from 'react'

import { IconProps } from '../../../../types'
import IconWrapper from '../../../IconWrapper'

const ActionValidIconMedium: React.FC<IconProps> = (props) => (
  <IconWrapper {...props}>
    <path
      fillRule="evenodd"
      d="m10.087 18.794 7.335-11.526-.844-.536-6.665 10.474-3.56-3.56-.707.708 4.441 4.44Z M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-1 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
    />
  </IconWrapper>
)

export default ActionValidIconMedium
